import React, {useState} from 'react';
import _ from "lodash";
import {Table} from "react-bootstrap";
import OneConterpartyTable from "./oneConterpartyTable";
import numberFormat from "../../../helpers/numberFormat";
import {Link} from "react-router-dom";
import MoreFunctionButton from "./moreFunctionButton";
import {capitalizeFirstLetter} from "../../../helpers/capitalizeFirstLetter";
import ServiceQuickEditModal from "../../racoon/components/serviceQuickEditModal";

const isKrs3300 = (row) => !!row.idInOneC && Math.floor(Number(row.krsBuyer)) === 3300

const baseObj = {
  "operation": "",
  "pax": "",
  "BSO": "",
  "route": "",
  "total": 0,
  "flightDate": ""
}
const SaleTable = ({editbleArray,setEditableArray,cb, showCol, setShowCol, onReload, edit}) => {
  const style = {"display":"none"}
  const [editRow, setEditRow] = useState(null)

  const editing = (index, value,name)=>{
    const all = structuredClone(editbleArray)
    if(name==='total' ||name==='krsBuyer'||name==='krsKayar'){
      all.tableData.tableData[index][name] = +value.replace(/\s/g, '').replace(',','.')
    } else if(name==='counterparty' || name==='date' ){
      all.tableData.header[name] = value
    }
    else{
      all.tableData.tableData[index][name] = value
    }
    setEditableArray(all)
  }

  const removeRow = (index) =>{
    if(window.confirm(`Вы уверены что хотите удалить ${editbleArray.tableData.tableData[index].operation}`)){
      const arr = structuredClone(editbleArray.tableData)
      arr.tableData.splice(index, 1)
      setEditableArray({...editbleArray,tableData:arr})
    }
  }
  const addRow = (index, direction) =>{
    const arr = structuredClone(editbleArray.tableData)
    if(direction === 'up'){
      arr.tableData.splice(index, 0, baseObj)
    }else{
      arr.tableData.splice(index+1, 0, baseObj)
    }
    setEditableArray({...editbleArray,tableData:arr})
  }
  const colSpan = () =>{
    if(!showCol.name && !showCol.krs || !showCol.name && showCol.krs){
      return 6
    }else{
      return  5
    }
  }

  return (
    <div className={'text-black mb-2'}
         // id={getAllLenght()}
    >
      <h2 className={'text-center mt-4 mb-4'}>Краткий реестр продаж по покупателю</h2><br/>
      <div>
        <div className={'d-flex'}>
          Покупатель:
          <div contentEditable
                           suppressContentEditableWarning
                           className={'ml-2'}
                           onBlur={e =>
                             editing(0, e.currentTarget.textContent, "counterparty")}>
          {editbleArray.tableData.header.counterparty}
        </div>
        </div>
        {editbleArray.tableData?.createTime && <div>Сформирован: {editbleArray.tableData?.createTime} {editbleArray.createdBy || editbleArray.tableData?.createdBy}</div>}
        <div className={'d-flex'}>
          Период
          <div contentEditable
                      suppressContentEditableWarning
                      className={'ml-2'}
                      onBlur={e =>
                        editing(0, e.currentTarget.textContent, "date")}>
          {editbleArray.tableData.header.date}
        </div>
        </div>
        {editbleArray.tableData.length === 0 ? <div onClick={() => addRow(0, 'down', 0)} style={{cursor: 'pointer'}}>
          Добавить строку <i className={"fa fa-plus ml-2 text-primary"}/>
        </div> : <br/>}
      </div>
      <Table striped bordered hover>
        <thead>
        <tr>
          <td>№</td>
          <td style={!showCol.name ? {} : style}>Документ/Операция</td>
          <td>Пассажир</td>
          <td>Назначение</td>
          <td>Описание</td>
          <td>Дата вылета</td>
          <td style={showCol.krs ? {} : style}>КРС покупателя</td>
          <td style={showCol.krs ? {} : style}>КРС Kayar</td>
          <td>Итого</td>
        </tr>
        </thead>
        <tbody>
        {editbleArray.tableData.tableData.map((inv, i) => {
          const krs3300 = isKrs3300(inv)
          return <tr key={i}
                     className={krs3300 && !inv.transferred ? 'register-krs-edit' : undefined}
                     style={inv.transferred ? {backgroundColor: 'rgba(253, 57, 122,0.35)'} : krs3300 ? {backgroundColor: 'rgba(255,0,0,0.22)'} : {}}>
            <td>
              <div className={'d-flex gap-1'}>
                <div>{i + 1}.</div>
                <div className={'notVisible'} >{inv.from1C ? '1C' : 'Б'}</div>
              </div>
            </td>
            <td style={!showCol.name ? {} : style}
                contentEditable={!!!inv.bookingId}
                suppressContentEditableWarning={!!!inv.bookingId}
                onBlur={e => {
                  if(!!!inv.bookingId) {
                    editing(i, e.currentTarget.textContent, "operation")
                  }
                }}
            >{inv.bookingId ?
              <Link to={inv.baseLink + inv.bookingId} target={'_blank'}>{inv.operation}</Link> : inv.operation}
              {!edit && krs3300 && inv.bookingId && <i
                className="fa fa-pencil text-primary text-black ml-2 notVisible"
                style={{cursor: 'pointer'}}
                onClick={() => setEditRow({
                  siteId: inv.bookingId,
                  itemNumber: inv.idInOneC,
                  description: inv.route
                })}
              />}
            </td>
            <td contentEditable
                suppressContentEditableWarning
                onBlur={e => editing(i, e.currentTarget.textContent, "pax")}>{inv.pax}</td>
            <td contentEditable
                suppressContentEditableWarning style={{whiteSpace: "nowrap"}}
                onBlur={e => editing(i, e.currentTarget.textContent, "BSO")}>{inv.BSO} {!!inv.idInOneC ? <><br/>{inv.idInOneC}</> :''}</td>
            <td contentEditable
                suppressContentEditableWarning
                onBlur={e => editing(i, e.currentTarget.textContent, "route")}>{capitalizeFirstLetter(inv.route)}</td>
            <td contentEditable
                suppressContentEditableWarning style={{whiteSpace: "nowrap"}}
                onBlur={e => editing(i, e.currentTarget.textContent, "flightDate")}>{inv.flightDate}</td>
            <td contentEditable
                suppressContentEditableWarning className={'text-end'} style={showCol.krs ? {} : style}
                onBlur={e => editing(i, e.currentTarget.textContent, "krsBuyer")}>{inv.krsBuyer ? numberFormat(inv.krsBuyer) : ''}</td>
            <td contentEditable
                suppressContentEditableWarning className={'text-end'} style={showCol.krs ? {} : style}
                onBlur={e => editing(i, e.currentTarget.textContent, "krsKayar")}>{inv.krsKayar ? numberFormat(inv.krsKayar) : ''}</td>
            <td contentEditable
                suppressContentEditableWarning className={'text-end'}
                onBlur={e => editing(i, e.currentTarget.textContent, "total")}>{numberFormat(inv.total)}</td>
            <td style={{border: 'none'}} id={'notVisible'}>
              <MoreFunctionButton removeRow={() => removeRow(i)} addRow={(direction) => {
                addRow(i, direction)
              }}/>
            </td>
          </tr>
        })}

        <tr>
          <th colSpan={colSpan()}>Итого</th>
          <th style={showCol.krs ? {} : style}
              className={'text-end'}>{numberFormat(_.sumBy(editbleArray.tableData.tableData,'krsBuyer')) || 0}</th>
          <th style={showCol.krs ? {} : style}
              className={'text-end'}>{numberFormat(_.sumBy(editbleArray.tableData.tableData, 'krsKayar'))|| 0}</th>
          <th className={'text-end'}>{numberFormat(_.sumBy(editbleArray.tableData.tableData, 'total')) || 0}</th>
        </tr>
        </tbody>
      </Table>
      {editRow && <ServiceQuickEditModal
        row={editRow}
        onHide={() => setEditRow(null)}
        onSaved={onReload}
      />}
    </div>
  );
};

export default SaleTable;
